import script from "./DetalleAsteBerdeaView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleAsteBerdeaView.vue?vue&type=script&setup=true&lang=js"

import "./DetalleAsteBerdeaView.vue?vue&type=style&index=0&id=5fe82c03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe82c03"]])

export default __exports__